import { PrismicRichText } from '@prismicio/react'

import linkResolver from '@lib/prismic/link-resolver'
import htmlSerializer from '@lib/prismic/serializer'

// Rich Text
interface Props {
	slice: any
}

export default function RichText({ slice }: Props) {
	// console.log('RichText Slice ->', slice)

	return (
		<section className="rich-text section">
			<div className="container">
				<div className="prose max-w-none text-[16px] md:text-base">
					<PrismicRichText
						field={slice.primary.section_body}
						linkResolver={linkResolver}
						components={htmlSerializer}
					/>
				</div>
			</div>
		</section>
	)
}
